import React from "react";

import { Props } from "./types";

function ToggleArrow({ className, styles }: Props) {
  return (
    <svg className={className} style={styles} viewBox="0 0 24 24">
      <g transform="translate(-2244 12083)">
        <rect
          id="Rectangle_5581"
          data-name="Rectangle 5581"
          width="24"
          height="24"
          rx="4"
          transform="translate(2244 -12083)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Icon_awesome-angle-up"
          data-name="Icon awesome-angle-up"
          d="M6.391,17.944,11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z"
          transform="translate(2250.223 -12082.313)"
          fill="#fff"
        />
        <path
          id="Icon_awesome-angle-up-2"
          data-name="Icon awesome-angle-up"
          d="M6.391,17.944l3.5-3.5L11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z"
          transform="translate(2250.223 -12088.619)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export { ToggleArrow };
